import * as companyTypes from "../../types/admin/companyTypes";

export const createCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_CREATE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.ADMIN_CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        newCompanyRegisterinfo: payload,
        error: "",
      };
    case companyTypes.ADMIN_CREATE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        newCompanyRegisterinfo: {},
      };
    default:
      return state;
  }
};
// export const addModulesInCompanyReducer = (state = {}, action) => {
//   const { type, payload } = action;
//   switch (type) {
//     case ADMIN_ADD_MODULES_IN_COMPANY_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case ADMIN_ADD_MODULES_IN_COMPANY_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         newCompanyRegisterinfo: payload,
//         error: "",
//       };
//     case ADMIN_ADD_MODULES_IN_COMPANY_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: payload,
//         newCompanyRegisterinfo: {},
//       };
//     default:
//       return state;
//   }
// };

export const activeSubscriptionReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeSubscripionInfo: payload,
        error: "",
      };
    case companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        activeSubscripionInfo: {},
      };
    default:
      return state;
  }
};

export const trailSubscriptionReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_TRAIL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        trailLoadings: true,
      };
    case companyTypes.ADMIN_TRAIL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        trailLoadings: false,
        trailSubscripionInfo: payload,
        trailErrors: "",
      };
    case companyTypes.ADMIN_TRAIL_SUBSCRIPTION_FAIL:
      return {
        ...state,
        trailLoadings: false,
        trailErrors: payload,
        trailSubscripionInfo: {},
      };
    default:
      return state;
  }
};

export const getDepartmentListReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.ADMIN_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        departmentList: payload,
        error: "",
      };
    case companyTypes.ADMIN_DEPARTMENT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        departmentList: {},
      };
    default:
      return state;
  }
};

export const getUserFromDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_REQUEST:
      return {
        ...state,
        departmentUserLoading: true,
      };
    case companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_SUCCESS:
      return {
        ...state,
        departmentUserLoading: false,
        departmentUserInfo: payload,
        departmentUserError: "",
      };
    case companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_FAIL:
      return {
        ...state,
        departmentUserLoading: false,
        departmentUserError: payload,
        departmentUserInfo: [],
      };
    default:
      return state;
  }
};

export const inviteEmailListReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_INVITE_BY_EMAIL_REQUEST:
      return {
        ...state,
        inviteLoading: true,
      };
    case companyTypes.ADMIN_INVITE_BY_EMAIL_SUCCESS:
      return {
        ...state,
        inviteLoading: false,
        inviteEmailInfo: payload,
        inviteError: "",
      };
    case companyTypes.ADMIN_INVITE_BY_EMAIL_FAIL:
      return {
        ...state,
        inviteLoading: false,
        inviteError: payload,
        inviteEmailInfo: {},
      };
    default:
      return state;
  }
};

export const addDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_ADD_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        addDepartLoading: true,
      };
    case companyTypes.ADMIN_ADD_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        addDepartLoading: false,
        addDepartInfo: payload,
        addDepartError: "",
      };
    case companyTypes.ADMIN_ADD_DEPARTMENT_LIST_FAIL:
      return {
        ...state,
        addDepartLoading: false,
        addDepartError: payload,
        addDepartInfo: {},
      };
    default:
      return state;
  }
};

export const editDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_UPDATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        editDepartLoading: true,
      };
    case companyTypes.ADMIN_UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        editDepartLoading: false,
        editDepartInfo: payload,
        editDepartError: "",
      };
    case companyTypes.ADMIN_UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        editDepartLoading: false,
        editDepartError: payload,
        editDepartInfo: {},
      };
    default:
      return state;
  }
};

export const addUserInDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        userDepartLoading: true,
      };
    case companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        userDepartLoading: false,
        userDepartInfo: payload,
        userDepartError: "",
      };
    case companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_FAIL:
      return {
        ...state,
        userDepartLoading: false,
        userDepartError: payload,
        userDepartInfo: {},
      };
    default:
      return state;
  }
};

export const deleteDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        deleteDepartLoading: true,
      };
    case companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        deleteDepartLoading: false,
        deleteDepartInfo: payload,
        deleteDepartError: "",
      };
    case companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_FAIL:
      return {
        ...state,
        deleteDepartLoading: false,
        deleteDepartError: payload,
        deleteDepartInfo: {},
      };
    default:
      return state;
  }
};

export const addGoalsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_ADD_GOALS_REQUEST:
      return {
        ...state,
        addGoalsLoading: true,
      };
    case companyTypes.ADMIN_ADD_GOALS_SUCCESS:
      return {
        ...state,
        addGoalsLoading: false,
        addGoalsInfo: payload,
        addGoalsError: "",
      };
    case companyTypes.ADMIN_ADD_GOALS_FAIL:
      return {
        ...state,
        addGoalsLoading: false,
        addGoalsError: payload,
        addGoalsInfo: {},
      };
    default:
      return state;
  }
};

export const updateCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_REQUEST:
      return {
        ...state,
        updateCompanyLoading: true,
      };
    case companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_SUCCESS:
      return {
        ...state,
        updateCompanyLoading: false,
        updateCompanyInfo: payload,
        updateCompanyError: "",
      };
    case companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_FAIL:
      return {
        ...state,
        updateCompanyLoading: false,
        updateCompanyError: payload,
        updateCompanyInfo: {},
      };
    default:
      return state;
  }
};

export const updateCompanyLogoReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_UPDATE_COMPANY_LOGO_REQUEST:
      return {
        ...state,
        updateCompanyLogoLoading: true,
      };
    case companyTypes.ADMIN_UPDATE_COMPANY_LOGO_SUCCESS:
      return {
        ...state,
        updateCompanyLogoLoading: false,
        updateCompanyLogoInfo: payload,
        updateCompanyLogoError: "",
      };
    case companyTypes.ADMIN_UPDATE_COMPANY_LOGO_FAIL:
      return {
        ...state,
        updateCompanyLogoLoading: false,
        updateCompanyLogoError: payload,
        updateCompanyLogoInfo: {},
      };
    default:
      return state;
  }
};

export const addCompanyModulesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_ADD_COMPANY_MODULES_REQUEST:
      return {
        ...state,
        addCompanyModulesLoading: true,
      };
    case companyTypes.ADMIN_ADD_COMPANY_MODULES_SUCCESS:
      return {
        ...state,
        addCompanyModulesLoading: false,
        addCompanyModulesInfo: payload,
        addCompanyModulesError: "",
      };
    case companyTypes.ADMIN_ADD_COMPANY_MODULES_FAIL:
      return {
        ...state,
        addCompanyModulesLoading: false,
        addCompanyModulesError: payload,
        addCompanyModulesInfo: {},
      };
    default:
      return state;
  }
};

export const addJobBoardLinkReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADD_JOB_BOARD_LINK_REQUEST:
      return {
        ...state,
        addJobBoardLinkLoading: true,
      };
    case companyTypes.ADD_JOB_BOARD_LINK_SUCCESS:
      return {
        ...state,
        addJobBoardLinkLoading: false,
        addJobBoardLinkInfo: payload,
        addJobBoardLinkError: "",
      };
    case companyTypes.ADD_JOB_BOARD_LINK_FAIL:
      return {
        ...state,
        addJobBoardLinkLoading: false,
        addJobBoardLinkError: payload,
        addJobBoardLinkInfo: {},
      };
    default:
      return state;
  }
};

export const getJobBoardLinkReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.GET_JOB_BOARD_LINK_REQUEST:
      return {
        ...state,
        getJobBoardLinkLoading: true,
      };
    case companyTypes.GET_JOB_BOARD_LINK_SUCCESS:
      return {
        ...state,
        getJobBoardLinkLoading: false,
        getJobBoardLinkInfo: payload,
        getJobBoardLinkError: "",
      };
    case companyTypes.GET_JOB_BOARD_LINK_FAIL:
      return {
        ...state,
        getJobBoardLinkLoading: false,
        getJobBoardLinkError: payload,
        getJobBoardLinkInfo: {},
      };
    default:
      return state;
  }
};

export const leaveCategoryImportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.LEAVE_CATEGORY_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.LEAVE_CATEGORY_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.LEAVE_CATEGORY_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const userQuotaImportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.USER_QUOTA_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.USER_QUOTA_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.USER_QUOTA_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

// export const advancedUserQuotaImportReducer = (state = {}, action) => {
//   const { type, payload } = action;
//   switch (type) {
//     case companyTypes.USER_QUOTA_IMPORT_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case companyTypes.USER_QUOTA_IMPORT_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         info: payload,
//         error: "",
//       };
//     case companyTypes.USER_QUOTA_IMPORT_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: payload,
//         info: {},
//       };
//     default:
//       return state;
//   }
// };

export const shiftImportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.SHIFT_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.SHIFT_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.SHIFT_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};
export const advancedUserQuotaImportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.USER_QUOTA_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.USER_QUOTA_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.USER_QUOTA_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const payrollImportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.PAYROLL_IMPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.PAYROLL_IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.PAYROLL_IMPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const editTeamReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.ADMIN_TEAM_UPDATE_REQUEST:
      return {
        ...state,
        editTeamLoading: true,
      };
    case companyTypes.ADMIN_TEAM_UPDATE_SUCCESS:
      return {
        ...state,
        editTeamLoading: false,
        editTeamInfo: payload,
        editTeamError: "",
      };
    case companyTypes.ADMIN_TEAM_UPDATE_FAIL:
      return {
        ...state,
        editTeamLoading: false,
        editTeamError: payload,
        editTeamInfo: {},
      };
    default:
      return state;
  }
};

export const sendHRLetterReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.SEND_HR_LETTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.SEND_HR_LETTER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.SEND_HR_LETTER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const getHRLettersReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.GET_HR_LETTERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.GET_HR_LETTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case companyTypes.GET_HR_LETTERS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const getCompanyAppsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.GET_COMPANY_APPS_REQUEST:
      return {
        ...state,
        companyAppsloading: true,
      };
    case companyTypes.GET_COMPANY_APPS_SUCCESS:
      return {
        ...state,
        companyAppsloading: false,
        companyApps: payload,
        error: "",
      };
    case companyTypes.GET_COMPANY_APPS_FAIL:
      return {
        ...state,
        companyAppsloading: false,
        error: payload,
        companyApps: undefined,
      };
    case companyTypes.UPDATE_COMPANY_APPS_LOCAL:
      return {
        ...state,
        companyAppsloading: false,
        companyApps: payload,
        error: "",
      };
    default:
      return state;
  }
};

export const getAllowedAppsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.GET_ALLOWED_APPS_REQUEST:
      return {
        ...state,
        allowedAppsloading: true,
      };
    case companyTypes.GET_ALLOWED_APPS_SUCCESS:
      return {
        ...state,
        allowedAppsloading: false,
        allowedApps: payload,
        error: "",
      };
    case companyTypes.GET_ALLOWED_APPS_FAIL:
      return {
        ...state,
        allowedAppsloading: false,
        error: payload,
        allowedApps: undefined,
      };

    default:
      return state;
  }
};
export const saveCompanyAppsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyTypes.SAVE_COMPANY_APPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case companyTypes.SAVE_COMPANY_APPS_SUCCESS:
      return {
        ...state,
        loading: false,
        savedApps: payload,
        error: "",
      };
    case companyTypes.SAVE_COMPANY_APPS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        savedApps: {},
      };
    default:
      return state;
  }
};
